import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NotificationEmailConfig } from '@app/modules/reports/types/report.types';
import { NotificationProfileModel, TemplateType } from '@core/core.types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-approve-report-preview-email',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './approve-report-preview-email.component.html',
})
export class ApproveReportPreviewEmailComponent {
  public emailConfig = input<NotificationEmailConfig>();
  public notificationProfile = input<NotificationProfileModel>();
  public templateType = input<TemplateType>();

  public sendEmail = output<boolean>();

  protected onEditEmail() {
    this.sendEmail.emit(false);
  }

  protected onSendEmail() {
    this.sendEmail.emit(true);
  }

  protected readonly TemplateType = TemplateType;
}
